import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit'
import { RootState } from 'redux/store'
import { StripePaymentRequest } from './stripe-payment-request-types'

// This will be overridden when the store is initialized with actual config
export const initialState: StripePaymentRequest = {
  walletType: null,
  canMakePayment: false,
}

export const stripePaymentRequestSlice = createSlice({
  name: 'stripePaymentRequest',
  initialState,
  reducers: {
    setCanMakePayment: (state, action: PayloadAction<boolean>) => {
      state.canMakePayment = action.payload
    },

    setWalletType: (state, action: PayloadAction<'APPLEPAY' | 'GPAY' | null>) => {
      state.walletType = action.payload
    },
  },
})

export const { setCanMakePayment, setWalletType } = stripePaymentRequestSlice.actions

export const checkCanMakePayment = () => (_dispatch: Dispatch, getState: () => RootState) => {
  const state = getState()

  return state.order.stripePaymentRequest.canMakePayment
}

export const checkWalletType = () => (_dispatch: Dispatch, getState: () => RootState) => {
  const state = getState()

  return state.order.stripePaymentRequest.walletType
}

export default stripePaymentRequestSlice.reducer
